import React, { Component } from "react";

import checkAndComparePMaxValue  from "./pMaxCheck";

import logo from "../images/header/logo-desk.png";
import mobileLogo from "../images/header/logo-mob.png";
import callLogo from "../images/header/call.jpg";

import "../css/header.less";

export class Header extends Component {
  render() {
    const isPerfmax = checkAndComparePMaxValue();
    const contactHref = isPerfmax ? "javascript:void(0)" : `tel:${this.props.contact}`;
    const cursorClassName = isPerfmax ? "cursor-default" : "";
    return (
      <header className="container-fluid header-block text-center bg-white navbar navbar-expand">
        <img src={logo} alt="desktop-logo" title="volkswagen" className="logo-desk d-none d-md-block" />
        <img src={mobileLogo} alt="mobile-logo" className="logo-mob d-block d-md-none" />
        <div className="right-col">
          <p className="name">{this.props.dealer}</p>
          <a href={contactHref}
            className={`contact-number ${cursorClassName}`}
            id="header_call"
          >
            <img src={callLogo} alt="call-logo" /> {this.props.contact}
          </a>
        </div>
      </header>
    );
  }
}

export default Header;
